var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',[_c('v-row',{attrs:{"fluid":""}},[_c('logo',{staticClass:"mr-auto"})],1),_vm._v(" "),_c('nuxt')],1)],1),_vm._v(" "),_c('Footer',{attrs:{"fixed":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }